import React, { type ReactElement } from "react";

import { mmToInches } from "../shared/helpers.js";
import type { Size as SizeType } from "../types.js";
import Cell from "./Cell.js";
import { FillAmount } from "./FillAmount.js";

type Props = {
	/** If any size in the category has a value for the fill options. */
	hasAny: boolean;
	size: SizeType;
};

/**
 *
 *
 * @param props The props for the component.
 * @returns The component.
 */
export default function Size(props: Props): ReactElement {
	const { hasAny, size } = props;
	const { maxFill, reccFill } = size;
	return (
		<tr>
			<Cell isHeader={true} scope="row">
				{size.dielines.find((d) => d.size.trim())?.size}
			</Cell>
			<Cell>
				<div className={"dl:flex dl:flex-col dl:justify-center"}>
					<div>
						{size.dimensions.width} x {size.dimensions.height}
						{size.dimensions.gusset !== 0 && ` x ${size.dimensions.gusset}`} mm
					</div>
					<div>
						{mmToInches(size.dimensions.width)} x{" "}
						{mmToInches(size.dimensions.height)}
						{!!size.dimensions.gusset &&
							` x ${mmToInches(size.dimensions.gusset)}`}{" "}
						in
					</div>
				</div>
			</Cell>
			{hasAny ? (
				<>
					<Cell>
						<FillAmount ml={maxFill} />
					</Cell>
					<Cell>
						<FillAmount ml={reccFill} />
					</Cell>
				</>
			) : (
				<Cell>
					<FillAmount ml={reccFill} />
				</Cell>
			)}
		</tr>
	);
}
